import "./index.css";
import "./App.css";
import "./style/form.css";
import "./style/store.css";
import "./style/master.css";
import "./style/data.css";
import "./style/area.css";
import "./style/tabel.css";
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ActiveSessionRedirect from "./Components/ActiveSessionRedirect";
import RequireAuth from "./Components/RequireAuth";
import Patch from "./Pages/Patch";
import PatchDetail from "./Pages/Patch/Detail";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import NotFound from "./Pages/NotFound";
import License from "./Pages/License";
import ProductMaster from "./Pages/ProductMaster";
import AddProductPage from "./Pages/ProductMaster/AddProductPage";
import EditProductPage from "./Pages/ProductMaster/EditProductPage";
import DataSurvey from "./Pages/DataSurvey";
import ViewDataTrx from "./Pages/DataSurvey/ViewDataTrx";
import AuditPlan from "./Pages/AuditPlan";
import ImportAudit from "./Pages/AuditPlan/ImportAudit";
import ImportProductGroup from "./Pages/ProductMaster/ImportProductGroup";
import Dashboard from "./Pages/Dashboard";
import DashboardDev from "./Pages/Dashboard/indexDev";
import UserManagement from "./Pages/UserManagement";
import SetUpStoreMaster from "./Pages/StoreMaster/SetupStoreMaster/Setup";
import SetUpArea from "./Pages/Report/ReportNonProjected/SetupArea";
import ProcessReportNonProjected from "./Pages/Report/ReportNonProjected/process";
import ExcelRequestImport from "./Pages/Report/ReportNonProjected/ExcelRequestImport";
// OLD VERSION
import ReportProjectedOldPivotData from "./Pages/Report/ReportProjected/ReportProjectedPivotData";
import ReportProjectedOldRawData from "./Pages/Report/ReportProjected/ReportProjectedRawData";
 
// NEW VERSION 
import ReportProjectedCustomChart from "./Pages/Report/ReportProjectedCustomChart";
import ReportProjectedNewPivotData from "./Pages/Report/ReportProjectedNewPivotData";
import ReportProjectedNewRawData from "./Pages/Report/ReportProjectedNewRawData";
 
import ProjectCustomQuestion from "./Pages/ProjectManagement/ProjectCustomQuestion";
import ProjectCustomQuestionStore from "./Pages/ProjectManagement/ProjectCustomQuestionStore";
import StoreMaster from "./Pages/StoreMaster";
import AddStorePage from "./Pages/StoreMaster/AddStorePage";
import EditStorePage from "./Pages/StoreMaster/EditStorePage";
import DataProcessing from "./Pages/DataProcessing";
import {
  CompletenessProduct,
  CompletenessStoreGT,
} from "./Pages/DataProcessing/DataProcessingCompletenessCheck";
import CellStoreMapping from "./Pages/DataProcessing/DataProcessingCellStoreMapping";
import PublicPhotoStore from "./Pages/PublicPhotoStore";
import PublicPhotoProduct from "./Pages/PublicPhotoProduct";
// import Map from './Pages/Map';
// import MapStore from './Pages/Map/MapStore';
import MapSurveyor from "./Pages/Map/Surveyor";
import MapSurveyorProvince from "./Pages/Map/Surveyor/EachProvince";
import MapSurveyorRegency from "./Pages/Map/Surveyor/EachRegency";
import AddProjectPage from "./Pages/ProjectManagement/AddProjectPage";
import ProjectManagement from "./Pages/ProjectManagement";
import CrosscodingBrand from "./Pages/DataProcessing/Crosscoding/Brand";
import CrosscodingProduct from "./Pages/DataProcessing/Crosscoding/Product";
import CrosscodedExcludedBrand from "./Pages/DataProcessing/Crosscoding/Brand/CrosscodedExcludedBrand";
import CrosscodedExcludedProduct from "./Pages/DataProcessing/Crosscoding/Product/CrosscodedExcludedProduct";
import AssignArea from "./Pages/Report/ReportNonProjected/SetupArea/Assign";
 
import SetupCategoryProduct from "./Pages/ProductMaster/SetUp/SetupCategory";
import SetupBrandProduct from "./Pages/ProductMaster/SetUp/SetupBrand";
import SetupPrincipalProduct from "./Pages/ProductMaster/SetUp/SetupPrincipal";
import SetupStockUnitProduct from "./Pages/ProductMaster/SetUp/SetupStockUnit";
import SetupUnitvolProduct from "./Pages/ProductMaster/SetUp/SetupUnitvol";
import SetupBrandCategoryMasterProduct from "./Pages/ProductMaster/SetUp/SetupBrandCategoryMaster";
 
import SetupPanel from "./Pages/StatModule/SetupPanel";
import SetupCategory from "./Pages/StatModule/SetupCategory";
import SetupStoreType from "./Pages/StatModule/SetupStoreType";
import SetupStoreTypeStat from "./Pages/StatModule/SetupStoreTypeStat";
import SetupStoreTypeMapping from "./Pages/StatModule/SetupStoreTypeMapping";
import SetupCell from "./Pages/StatModule/SetupCell";
import SetupMBD from "./Pages/StatModule/SetupMBD";
import ManageSetupMBD from "./Pages/StatModule/Manage/ManageSetupMBD";
import SetupDB from "./Pages/StatModule/SetupDB";
import ManageSetupDB from "./Pages/StatModule/Manage/ManageSetupDB";
import SetupBpsProvince from "./Pages/StatModule/SetupBpsProvince";
import SetupBpsRegency from "./Pages/StatModule/SetupBpsRegency";
import SetupBpsDistrict from "./Pages/StatModule/SetupBpsDistrict";
import SetupBpsSubDistrict from "./Pages/StatModule/SetupBpsSubDistrict";
import SetupAreaCode from "./Pages/StatModule/SetupAreaCode";
import SetupAreaCell from "./Pages/StatModule/SetupAreaCell";
import SetupAreaMapping from "./Pages/StatModule/SetupAreaMapping";
import SetupCellCodeMapping from "./Pages/StatModule/SetupCellCodeMapping";
import SetupCellAdjFactor from "./Pages/StatModule/SetupCellAdjFactor";
import SetupStorePanelCell from "./Pages/StatModule/SetupStorePanelCell";
import SetupSuperCategory from "./Pages/StatModule/SetupSuperCategory";
import SetupSuperBrand from "./Pages/StatModule/SetupSuperBrand";
import Profile from "./Pages/Profile";
import CopyProjectAdhocPage from "./Pages/ProjectManagement/CopyProjectAdhocPage";
import SetupCatalogReport from "./Pages/SetupCatalogReport";
import CustomFilterPage from "./Pages/SetupCatalogReport/CustomFilter";
// import CatalogReportSetup from "./Pages/Report/ReportNonProjected/CatalogReportSetup";
// import CellStoreHistory from "./Pages/DataProcessing/CellHistory/CellStore";
// import MBDCellHistory from "./Pages/DataProcessing/CellHistory/MBDCell";
 
// Feature flags — dibaca dari .env (default aman kalau tidak di-set)
const useNewProjectedReport = process.env.REACT_APP_PROJECTED_REPORT_VERSION === "new";
 
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <NotFound />,
  },
  {
    path: "/login",
    element: (
      <ActiveSessionRedirect>
        <Login />
      </ActiveSessionRedirect>
    ),
  },
  {
    path: "/patch-notes",
    element:
      process.env.REACT_APP_IS_SHOWING_MENU_PATCH_NOTES === "false" ? (
        <NotFound />
      ) : (
        <RequireAuth>
          <Patch />
        </RequireAuth>
      ),
  },
  {
    path: "/patch-notes/:id",
    element: (
      <RequireAuth>
        <PatchDetail />
      </RequireAuth>
    ),
  },
  {
    path: "/license",
    element: (
      <RequireAuth>
        <License />
      </RequireAuth>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
  },
  {
    path: "/dashboard-dev",
    element: (
      <RequireAuth>
        <DashboardDev />
      </RequireAuth>
    ),
  },
  {
    path: "/project-management",
    element: (
      <RequireAuth>
        <ProjectManagement />
      </RequireAuth>
    ), // for master edit (able to edit rdc)
  },
  {
    path: "/project-management/create",
    element: (
      <RequireAuth>
        <AddProjectPage />
      </RequireAuth>
    ), // for master edit (able to edit rdc)
  },
  {
    path: "/project-management/copy/:projectId",
    element: (
      <RequireAuth>
        <CopyProjectAdhocPage />
      </RequireAuth>
    ),
  },
  {
    path: "/project-management/custom-question-sku/:projectId",
    element: (
      <RequireAuth>
        <ProjectCustomQuestion />
      </RequireAuth>
    ),
  },
  {
    path: "/project-management/custom-question-store/:projectId",
    element: (
      <RequireAuth>
        <ProjectCustomQuestionStore />
      </RequireAuth>
    ),
  },
  {
    path: "/store-master",
    element: (
      <RequireAuth>
        <StoreMaster />
      </RequireAuth>
    ),
  },
  {
    path: "/store-master/create",
    element: (
      <RequireAuth>
        <AddStorePage />
      </RequireAuth>
    ),
  },
  {
    path: "/store-master/edit/:storeId",
    element: (
      <RequireAuth>
        <EditStorePage />
      </RequireAuth>
    ),
  },
  {
    path: "/product-master",
    element: (
      <RequireAuth>
        <ProductMaster />
      </RequireAuth>
    ),
  },
  {
    path: "/product-master/create",
    element: (
      <RequireAuth>
        <AddProductPage />
      </RequireAuth>
    ),
  },
  {
    path: "/product-master/edit/:productId",
    element: (
      <RequireAuth>
        <EditProductPage />
      </RequireAuth>
    ),
  },
  {
    path: "/data-survey",
    element: (
      <RequireAuth>
        <DataSurvey />
      </RequireAuth>
    ),
  },
  {
    path: "/data-survey/:surveyId/:storeId",
    element: (
      <RequireAuth>
        <ViewDataTrx />
      </RequireAuth>
    ),
  },
  {
    path: "/audit-plan",
    element: (
      <RequireAuth>
        <AuditPlan />
      </RequireAuth>
    ),
  },
  {
    path: "/audit-plan/import",
    element: (
      <RequireAuth>
        <ImportAudit />
      </RequireAuth>
    ),
  },
  {
    path: "/product-group/import",
    element: (
      <RequireAuth>
        <ImportProductGroup />
      </RequireAuth>
    ),
  },
  {
    path: "/user-management",
    element: (
      <RequireAuth>
        <UserManagement />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing",
    element: (
      <RequireAuth>
        <DataProcessing />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/crosscode-brand",
    element: (
      <RequireAuth>
        <CrosscodingBrand />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/crosscode-brand/:listType",
    element: (
      <RequireAuth>
        <CrosscodedExcludedBrand />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/crosscode-product/:listType",
    element: (
      <RequireAuth>
        <CrosscodedExcludedProduct />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/crosscode-product",
    element: (
      <RequireAuth>
        <CrosscodingProduct />
      </RequireAuth>
    ),
  },
  // {
  //   path: "/data-processing/cell-history/cell-store",
  //   element: (
  //     <RequireAuth>
  //       <CellStoreHistory />
  //     </RequireAuth>
  //   ),
  // },
  // {
  //   path: "/data-processing/cell-history/mbd-cell",
  //   element: (
  //     <RequireAuth>
  //       <MBDCellHistory />
  //     </RequireAuth>
  //   ),
  // },
  {
    path: "/non-projected-reporting",
    element:
      process.env.REACT_APP_IS_SHOWING_MENU_NON_PROJECTED === "false" ? (
        <NotFound />
      ) : (
        <RequireAuth>
          <ProcessReportNonProjected />
        </RequireAuth>
      ),
  },
  {
    path: "/data-processing/cell-store-mapping/:dataId",
    element: (
      <RequireAuth>
        <CellStoreMapping />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/completeness-check-store/:id",
    element: (
      <RequireAuth>
        <CompletenessStoreGT />
      </RequireAuth>
    ),
  },
  {
    path: "/data-processing/completeness-check-product/:id",
    element: (
      <RequireAuth>
        <CompletenessProduct />
      </RequireAuth>
    ),
  },
  {
    path: "/non-projected-reporting/preview/:selectedReportGroup/:selectedReport",
    element: (
      <RequireAuth>
        <ExcelRequestImport />
      </RequireAuth>
    ),
  },
  // Projected Reporting (Chart untuk versi baru / Pivot lama untuk domain lain)
  {
    path: "/projected-reporting",
    element: (
      <RequireAuth>
        {useNewProjectedReport ? <ReportProjectedCustomChart /> : <ReportProjectedOldPivotData />}
      </RequireAuth>
    ),
  },
  // Projected Reporting Pivot: route baru, hanya tersedia di versi baru (Cigarette)
  {
    path: "/projected-reporting-pivot",
    element: useNewProjectedReport ? (
      <RequireAuth>
        <ReportProjectedNewPivotData />
      </RequireAuth>
    ) : (
      <NotFound />
    ),
  },
  {
    path: "/projected-reporting-tabular",
    element: (
      <RequireAuth>
        {useNewProjectedReport ? <ReportProjectedNewRawData /> : <ReportProjectedOldRawData />}
      </RequireAuth>
    ),
  },
  {
    path: "/setup-store-master",
    element: (
      <RequireAuth>
        <SetUpStoreMaster />
      </RequireAuth>
    ),
  },
  {
    path: "/setup-area",
    children: [
      {
        path: "",
        element: (
          <RequireAuth>
            <SetUpArea />
          </RequireAuth>
        ),
      },
      {
        path: "assign",
        element: (
          <RequireAuth>
            <AssignArea />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    path: "/setup-product-master",
    children: [
      {
        path: "",
        element: (
          <RequireAuth>
            <NotFound />
          </RequireAuth>
        ),
      },
      {
        path: "category",
        element: (
          <RequireAuth>
            <SetupCategoryProduct />
          </RequireAuth>
        ),
      },
      {
        path: "brand",
        element: (
          <RequireAuth>
            <SetupBrandProduct />
          </RequireAuth>
        ),
      },
      {
        path: "principal",
        element: (
          <RequireAuth>
            <SetupPrincipalProduct />
          </RequireAuth>
        ),
      },
      {
        path: "stock-unit",
        element: (
          <RequireAuth>
            <SetupStockUnitProduct />
          </RequireAuth>
        ),
      },
      {
        path: "unitvol",
        element: (
          <RequireAuth>
            <SetupUnitvolProduct />
          </RequireAuth>
        ),
      },
      {
        path: "brand-category-master",
        element: (
          <RequireAuth>
            <SetupBrandCategoryMasterProduct />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    path: "/stat-module",
    children: [
      {
        path: "setup-panel",
        element: (
          <RequireAuth>
            <SetupPanel />
          </RequireAuth>
        ),
      },
      {
        path: "setup-category",
        element: (
          <RequireAuth>
            <SetupCategory />
          </RequireAuth>
        ),
      },
      {
        path: "setup-catalog-report",
        element: (
          <RequireAuth>
            <SetupCatalogReport />
          </RequireAuth>
        ),
      },
      {
        path: "setup-catalog-report/:id",
        element: (
          <RequireAuth>
            <SetupCatalogReport />
          </RequireAuth>
        ),
      },
      {
        path: "setup-catalog-report/:catalogId/custom-filter/:reportLineId",
        element: (
          <RequireAuth>
            <CustomFilterPage />
          </RequireAuth>
        ),
      },
      {
        path: "setup-store-type",
        element: (
          <RequireAuth>
            <SetupStoreType />
          </RequireAuth>
        ),
      },
      {
        path: "setup-store-type-stat",
        element: (
          <RequireAuth>
            <SetupStoreTypeStat />
          </RequireAuth>
        ),
      },
      {
        path: "setup-store-type-mapping",
        element: (
          <RequireAuth>
            <SetupStoreTypeMapping />
          </RequireAuth>
        ),
      },
      {
        path: "setup-cell",
        element: (
          <RequireAuth>
            <SetupCell />
          </RequireAuth>
        ),
      },
      {
        path: "setup-mbd",
        children: [
          {
            path: "",
            element: (
              <RequireAuth>
                <SetupMBD />
              </RequireAuth>
            ),
          },
          {
            path: "manage",
            element: (
              <RequireAuth>
                <ManageSetupMBD />
              </RequireAuth>
            ),
          },
          {
            path: "manage/:dataId/:panelCode/:mbdCode/:descValue",
            element: (
              <RequireAuth>
                <ManageSetupMBD />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: "setup-db",
        children: [
          {
            path: "",
            element: (
              <RequireAuth>
                <SetupDB />
              </RequireAuth>
            ),
          },
          {
            path: "manage",
            element: (
              <RequireAuth>
                <ManageSetupDB />
              </RequireAuth>
            ),
          },
          {
            path: "manage/:panelCode/:dbName",
            element: (
              <RequireAuth>
                <ManageSetupDB />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: "setup-bps-province",
        element: (
          <RequireAuth>
            <SetupBpsProvince />
          </RequireAuth>
        ),
      },
      {
        path: "setup-bps-regency",
        element: (
          <RequireAuth>
            <SetupBpsRegency />
          </RequireAuth>
        ),
      },
      {
        path: "setup-bps-district",
        element: (
          <RequireAuth>
            <SetupBpsDistrict />
          </RequireAuth>
        ),
      },
      {
        path: "setup-bps-sub-district",
        element: (
          <RequireAuth>
            <SetupBpsSubDistrict />
          </RequireAuth>
        ),
      },
      {
        path: "setup-area-code",
        element: (
          <RequireAuth>
            <SetupAreaCode />
          </RequireAuth>
        ),
      },
      {
        path: "setup-area-cell",
        element: (
          <RequireAuth>
            <SetupAreaCell />
          </RequireAuth>
        ),
      },
      {
        path: "setup-area-mapping",
        element: (
          <RequireAuth>
            <SetupAreaMapping />
          </RequireAuth>
        ),
      },
      {
        path: "setup-cell-code-mapping",
        element: (
          <RequireAuth>
            <SetupCellCodeMapping />
          </RequireAuth>
        ),
      },
      {
        path: "setup-cell-adj-factor",
        element: (
          <RequireAuth>
            <SetupCellAdjFactor />
          </RequireAuth>
        ),
      },
      {
        path: "setup-store-panel-cell",
        element: (
          <RequireAuth>
            <SetupStorePanelCell />
          </RequireAuth>
        ),
      },
      {
        path: "setup-super-category",
        element: (
          <RequireAuth>
            <SetupSuperCategory />
          </RequireAuth>
        ),
      },
      {
        path: "setup-super-brand",
        element: (
          <RequireAuth>
            <SetupSuperBrand />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    path: "/public-photo",
    children: [
      {
        path: "store/:storeId",
        element: <PublicPhotoStore />,
      },
      {
        path: "product/:productId",
        element: <PublicPhotoProduct />,
      },
    ],
  },
  // {
  //   path: "/map-project",
  //   element: <RequireAuth>
  // <Map /></RequireAuth >
  // },
  // {
  //   path: "/map-store-master",
  //   element: <RequireAuth>
  // <MapStore /></RequireAuth >
  // },
  {
    path: "/map-surveyor",
    element: (
      <RequireAuth>
        <MapSurveyor />
      </RequireAuth>
    ),
  },
  {
    path: "/map-surveyor/:provinceId",
    element: (
      <RequireAuth>
        <MapSurveyorProvince />
      </RequireAuth>
    ),
  },
  {
    path: "/map-surveyor/:provinceId/:regencyId/:mhid",
    element: (
      <RequireAuth>
        <MapSurveyorRegency />
      </RequireAuth>
    ),
  },
  {
    path: "/profile",
    element: (
      <RequireAuth>
        <Profile />
      </RequireAuth>
    ),
  },
]);